/**
 * All product constraints (example : numberMax, types etc...)
 */

export default {
  wc: {
    numberMax: 1,
    typeSrc: "glb",
    showAddButton: true,
    showReplaceButton: true,
    title: "Toilettes",
    titleSelectedObject: "Toilette",
  },
  partition: {
    numberMax: 10,
    allowedScale: [true, false, false],
    typeSrc: "jpg",
    showAddButton: false,
    showReplaceButton: false,
    title: "Cloisons",
    formContent:
      `<div class='containerFormScale py-3 px-4 text-start mt-3'>` +
      `<p style='color:#004555' class='barlow-bold fs-5 '>Entrez vos dimensions</p>` +
      `<div class='row'>` +
      `<div class='col-8'>` +
      `<form class="formMeasures">` +
      `<div class="row  align-items-center">
              <label for="lengthObject" class="col-sm-5 col-form-label" style="color:#004555;">Longueur</label>
              <div class="col-sm-7">
                  <input required type="number" placeholder="en mm"  class="form-control" id="lengthObject" name="lengthObject">
              </div>
          </div>` +
      `<button type="submit" data-type="partition" class="btn btn-primary barlow-regular p-0 submitFormMeasures submitFormMeasuresMasonry" style="border-radius:50px;background-color:transparent"><img src="./images/icons/icon_add_object_3.png"
             width="40" /></button>` +
      `</form>` +
      `</div>`,
    titleSelectedObject: "Cloison",
  },
  pipeBoxing: {
    numberMax: 10,
    form: "<p>TEST</p>",
    typeSrc: "jpg",
    showAddButton: false,
    showReplaceButton: false,
    title: "Coffrages",
    formContent:
      `<div class='containerFormScale py-3 px-4 text-start mt-3'>` +
      `<p style='color:#004555' class='barlow-bold fs-5 '>Entrez vos dimensions</p>` +
      `<div class='row'>` +
      `<div class='col-8'>` +
      `<form class="formMeasures">` +
      `<div class="row  align-items-center">
              <label for="lengthObject" class="col-sm-5 col-form-label" style="color:#004555;">Longueur</label>
              <div class="col-sm-7">
                  <input required type="number" placeholder="en mm"  class="form-control" id="lengthObject" name="lengthObject">
              </div>
          </div>` +
      `<div class="row mt-2 align-items-center">
              <label for="widthObject" class="col-sm-5 col-form-label" style="color:#004555;">Largeur</label>
              <div class="col-sm-7">
                  <input required type="number" placeholder="en mm"  class="form-control" id="widthObject" name="widthObject">
              </div>
          </div>` +
      `<div class="row mt-2 align-items-center">
              <label for="heightObject" class="col-sm-5 col-form-label" style="color:#004555;">Hauteur</label>
              <div class="col-sm-7">
                  <input required type="number" placeholder="en mm"  class="form-control" id="heightObject" name="heightObject">
              </div>
          </div>` +
      `<button type="submit" data-type="pipeBoxing" class="btn btn-primary barlow-regular p-0 submitFormMeasures submitFormMeasuresMasonry" style="border-radius:50px;background-color:transparent"><img src="./images/icons/icon_add_object_3.png"
             width="40" /></button>` +
      `</form>` +
      `</div>`,
    titleSelectedObject: "Coffrage",
  },
  furniture: {
    numberMax: 5,
    typeSrc: "glb",
    showAddButton: true,
    showReplaceButton: true,
    title: "Meubles",
    titleSelectedObject: "Meuble",
  },
  washBasin: {
    // meuble vasque
    numberMax: 1,
    typeSrc: "glb",
    showAddButton: true,
    showReplaceButton: true,
    title: "Meubles vasques",
    titleSelectedObject: "Meuble vasque",
  },
  radiator: {
    numberMax: 1,
    typeSrc: "glb",
    showAddButton: true,
    showReplaceButton: true,
    title: "Radiateurs",
    titleSelectedObject: "Sèche serviettes",
  },
  mirror: {
    numberMax: 1,
    typeSrc: "glb",
    showAddButton: true,
    showReplaceButton: true,
    title: "Miroir",
    titleSelectedObject: "Miroir",
  },
  washingMachine: {
    numberMax: 1,
    typeSrc: "glb",
    showAddButton: true,
    showReplaceButton: true,
    title: "Machines à laver",
    titleSelectedObject: "Machine à laver",
  },
  door: {
    numberMax: 1,
    typeSrc: "glb",
    showAddButton: true,
    showReplaceButton: true,
    title: "Portes",
    titleSelectedObject: "Porte",
  },
  window: {
    numberMax: Infinity,
    typeSrc: "glb",
    showAddButton: false,
    showReplaceButton: false,
    title: "Fenêtres",
    tooltip: true,
    formContent: `
                <input required placeholder="Hauteur en mm" type="number" name="heightObject" class="form-control inputForm mt-2 mb-2" />
                <input required placeholder="Longueur en mm" type="number" name="lengthObject" class="form-control inputForm" />
               `,
    titleSelectedObject: "Fenêtre",
  },
  showerTray: {
    // receveur
    numberMax: 1,
    typeSrc: "glb",
    tooltip: true, // show tooltip when clicked on card
    formContent: `
                <input required placeholder="Longueur en mm" type="number" name="lengthObject" min="700" max="2000" class="form-control inputForm" /><p class="mt-1 mb-0" style="font-size: 10px;">⚠️ Min 1200 pour paroi ouverte  </p>
                <input required placeholder="Largeur en mm" min="700" max="1000" type="number" name="widthObject" class="form-control inputForm mt-2 mb-2" />
                <span class="barlow-medium">PN</span>
                <div class="form-check form-check-inline mx-0 ms-1">
                  <input checked class="form-check-input me-1" type="radio" id="pn1" name="pnObject" value="24">
                  <label class="form-check-label barlow-bold" for="pn1">24</label>
                </div>
                <div class="form-check form-check-inline mx-0">
                    <input class="form-check-input me-1" type="radio" id="pn2" name="pnObject" value="18">
                    <label class="form-check-label barlow-bold" for="pn2">18</label>
                </div>`,
    showAddButton: false,
    showReplaceButton: false,
    title: "Receveurs",
    titleSelectedObject: "Receveur",
  },
  showerWall: {
    // paroi
    numberMax: Infinity,
    typeSrc: "glb",
    tooltip: true,
    formContent: {
      basseAngle: `<input min="0" max="2000" required placeholder="Longueur en mm" type="number" name="lengthObject" class="form-control inputForm mt-4 mb-2" /> <input min="0" max="2000" required type="number" placeholder="Largeur en mm"  class="form-control" id="widthObject" name="widthObject">`,
      basseDroite: `<input min="0" max="2000" required placeholder="Longueur en mm" type="number" name="lengthObject" class="form-control inputForm mt-4 mb-2" /> `,
      fixe: `<input min="400" max="1000" required placeholder="Longueur en mm" type="number" name="lengthObject" class="form-control inputForm mt-4" /><p class="mt-3" style="font-size: 13px;">⚠️ Compte rond </p>`,
      pliante: `<select class="form-select mb-2" name="lengthObject" aria-label="Default select example">
      <option selected value="600">600</option>
      <option value="700">700</option>
      <option value="800">800</option>
      <option value="900">900</option>
      <option value="1000">1000</option></select>  <span class="barlow-medium">Aimantée</span><br>
                <div class="form-check form-check-inline mx-0">
                  <input checked class="form-check-input " type="radio" id="aimantee1" name="aimanteeObject" value="1">
                  <label class="form-check-label barlow-bold" for="aimantee1">Oui</label>
                </div>
                <div class="form-check form-check-inline mx-0">
                    <input class="form-check-input " type="radio" id="aimantee2" name="aimanteeObject" value="0">
                    <label class="form-check-label barlow-bold" for="aimantee2">Non</label>
                </div>`,
      rabat: null,
      coulissante1vantail: `<input min="1550" max="2000" required placeholder="Longueur en mm" type="number" name="lengthObject" class="form-control inputForm mt-4" /><input min="1700" max="2500" required placeholder="Hauteur en mm" type="number" name="heightObject" class="form-control inputForm mt-2" />`,
      coulissante2vantaux: `<input min="1350" max="2000" required placeholder="Longueur en mm" type="number" name="lengthObject" class="form-control inputForm mt-4" /><input min="1700" max="2500" required placeholder="Hauteur en mm" type="number" name="heightObject" class="form-control inputForm mt-2" />`,
    },
    showAddButton: false,
    showReplaceButton: false,
    title: "Parois de douche",
    titleSelectedObject: "Paroi de douche",
    subType: [
      "fixe",
      "rabat",
      "coulissante1vantail",
      "coulissante2vantaux",
      "pliante",
      "basseAngle",
      "basseDroite",
    ],
  },
  showerPanel: {
    // panneau
    numberMax: Infinity,
    typeSrc: "jpg",
    showAddButton: false,
    showReplaceButton: false,
    formContent:
      `<p class="mt-4 text-start barlow-bold" style="color:#ffffff;font-size:14px;">⚠️ &nbsp; Le choix des coloris se fera en touchant les panneaux créés.</p>` +
      // Panneaux hauts
      `<div class="mt-3 divider category-title bebas-neue-regular fs-4">Panneaux hauts</div>` +
      `<div class='containerFormScale py-3 px-4 text-start mt-2'>` +
      `<p style='color:#004555' class='barlow-bold fs-5 '>Entrez vos dimensions</p>` +
      `<div class='row'>` +
      `<div class='col-8'>` +
      `<form class="formMeasures">` +
      `<div class="row mb-3 align-items-center barlow-medium">
            <label for="height" class="col-sm-5 col-form-label" style="color:#004555;">Hauteur</label>
            <div class="col-sm-7">
              <input min="0"  max="2500" required type="number" placeholder="en mm"  class="form-control" id="height" name="heightObject">
            </div>
          </div>` +
      `<div class="row  align-items-center">
              <label for="lengthObject" class="col-sm-5 col-form-label" style="color:#004555;">Longueur</label>
              <div class="col-sm-7">
                  <input min="0" required type="number" placeholder="en mm"  class="form-control" id="lengthObject" name="lengthObject">
              </div>
          </div>` +
      `<button type="submit" data-type="showerPanel" class="btn btn-primary barlow-regular p-0 submitFormMeasures submitFormMeasuresMasonry" style="border-radius:50px;background-color:transparent"><img src="./images/icons/icon_add_object_3.png"
             width="40" /></button>` +
      `<input type="hidden" value="kitDecor" name="subType" >` +
      `</form>` +
      `</div>` +
      `<div class='col-4 align-items-center align-content-center'>` +
      `</div>` +
      `</div>` +
      `</div>`+
      // Form panneau relief
      /* `<div class="mt-3 divider category-title bebas-neue-regular fs-4">Panneaux RELIEF</div>` +
      `<div class='containerFormScale py-3 px-4 text-start mt-2'>` +
      `<p style='color:#004555' class='barlow-bold fs-5 '>Entrez vos dimensions</p>` +
      `<div class='row'>` +
      `<div class='col-8'>` +
      `<form class="formMeasures">` +
      `<div class="row mb-3 align-items-center barlow-medium">
            <label for="height" class="col-sm-5 col-form-label" style="color:#004555;">Hauteur</label>
            <div class="col-sm-7">
              <input style="background-color:#bababa" required type="number" value="2000" disabled  placeholder="en mm"  class="form-control" id="height" name="heightObject">
            </div>
          </div>` +
      `<div class="row  align-items-center">
              <label for="lengthObject" class="col-sm-5 col-form-label" style="color:#004555;">Longueur</label>
              <div class="col-sm-7">
                  <input required type="number" min="0" placeholder="en mm"  class="form-control" id="lengthObject" name="lengthObject">
              </div>
          </div>` +
      `<button type="submit" data-type="showerPanel" class="btn btn-primary barlow-regular p-0 submitFormMeasures submitFormMeasuresMasonry" style="border-radius:50px;background-color:transparent"><img src="./images/icons/icon_add_object_3.png"
             width="40" /></button>` +
      `<input type="hidden" value="relief" name="subType" >` +
      `</form>` +
      `</div>` +
      `<div class='col-4 align-items-center align-content-center'>` +
      `</div>` +
      `</div>` +
      `</div>` + */
      // Form panneau slim
      /* `<div class="mt-3 divider category-title bebas-neue-regular fs-4">Panneaux SLIM</div>` +
      `<div class='containerFormScale py-3 px-4 text-start mt-2'>` +
      `<p style='color:#004555' class='barlow-bold fs-5 '>Entrez vos dimensions</p>` +
      `<div class='row'>` +
      `<div class='col-8'>` +
      `<form class="formMeasures">` +
      `<div class="row mb-3 align-items-center barlow-medium">
            <label for="height" class="col-sm-5 col-form-label" style="color:#004555;">Hauteur</label>
            <div class="col-sm-7">
              <input min="1950" max="2500" required type="number" placeholder="en mm"  class="form-control" id="height" name="heightObject">
            </div>
          </div>` +
      `<div class="row  align-items-center">
              <label for="lengthObject" class="col-sm-5 col-form-label" style="color:#004555;">Longueur</label>
              <div class="col-sm-7">
                  <input min="0"  required type="number" placeholder="en mm"  class="form-control" id="lengthObject" name="lengthObject">
              </div>
          </div>` +
      `<button type="submit" data-type="showerPanel" class="btn btn-primary barlow-regular p-0 submitFormMeasures submitFormMeasuresMasonry" style="border-radius:50px;background-color:transparent"><img src="./images/icons/icon_add_object_3.png"
             width="40" /></button>` +
      `<input type="hidden" value="slim" name="subType" >` +
      `</form>` +
      `</div>` +
      `<div class='col-4 align-items-center align-content-center'>` +
      `</div>` +
      `</div>` +
      `</div>` + */
      // form panneau bas
      `<div class="mt-3 divider category-title bebas-neue-regular fs-4">Panneaux BAS</div>` +
      `<div class='containerFormScale py-3 px-4 text-start mt-2'>` +
      `<p style='color:#004555' class='barlow-bold fs-5 '>Entrez vos dimensions</p>` +
      `<div class='row'>` +
      `<div class='col-8'>` +
      `<form class="formMeasures">` +
      `<div class="row mb-3 align-items-center barlow-medium">
            <label for="height" class="col-sm-5 col-form-label" style="color:#004555;">Hauteur</label>
            <div class="col-sm-7">
              <input  value="950" style="background-color:#bababa" disabled required type="number" placeholder="en mm"  class="form-control" id="height" name="heightObject">
            </div>
          </div>` +
      `<div class="row  align-items-center">
              <label for="lengthObject" class="col-sm-5 col-form-label" style="color:#004555;">Longueur</label>
              <div class="col-sm-7">
                  <input min="0" required type="number" placeholder="en mm"  class="form-control" id="lengthObject" name="lengthObject">
              </div>
          </div>` +
      `<button type="submit" data-type="showerPanel" class="btn btn-primary barlow-regular p-0 submitFormMeasures submitFormMeasuresMasonry" style="border-radius:50px;background-color:transparent"><img src="./images/icons/icon_add_object_3.png"
             width="40" /></button>` +
      `<input type="hidden" value="bas" name="subType" >` +
      `</form>` +
      `</div>` +
      `<div class='col-4 align-items-center align-content-center'>` +
      `</div>` +
      `</div>` +
      `</div>` +
      // Revêtements muraux
      `<div class="mt-3 divider category-title bebas-neue-regular fs-4">Revêtements muraux (douche)</div>` +
      `<div class='containerFormScale py-3 px-4 text-start mt-2'>` +
      `<p style='color:#004555' class='barlow-bold fs-5 '>Entrez vos dimensions</p>` +
      `<div class='row'>` +
      `<div class='col-8'>` +
      `<form class="formMeasures">` +
      `<div class="row mb-3 align-items-center barlow-medium">
            <label for="height" class="col-sm-5 col-form-label" style="color:#004555;">Hauteur</label>
            <div class="col-sm-7">
              <input  value="2500" style="background-color:#bababa" disabled required type="number" placeholder="en mm"  class="form-control" id="height" name="heightObject">
            </div>
          </div>` +
      `<div class="row  align-items-center">
              <label for="lengthObject" class="col-sm-5 col-form-label" style="color:#004555;">Longueur</label>
              <div class="col-sm-7">
                  <input min="0" required type="number" placeholder="en mm"  class="form-control" id="lengthObject" name="lengthObject">
              </div>
          </div>` +
      `<button type="submit" data-type="showerPanel" class="btn btn-primary barlow-regular p-0 submitFormMeasures submitFormMeasuresMasonry" style="border-radius:50px;background-color:transparent"><img src="./images/icons/icon_add_object_3.png"
             width="40" /></button>` +
      `<input type="hidden" value="wall" name="subType" >` +
      `</form>` +
      `</div>` +
      `<div class='col-4 align-items-center align-content-center'>` +
      `</div>` +
      `</div>` +
      `</div>`
      ,
    title: "Panneaux de douche",
    titleSelectedObject: "Panneau de douche",
  },
  showerGrabBar: {
    // barre de maintien
    numberMax: 3,
    typeSrc: "glb",
    showAddButton: true,
    showReplaceButton: true,
    title: "Barre de maintien",
    titleSelectedObject: "Barre de maintien",
  },
  showerFaucet: {
    // robinetterie
    numberMax: 1,
    typeSrc: "glb",
    showAddButton: true,
    showReplaceButton: true,
    title: "Robinetterie",
    titleSelectedObject: "Robinetterie",
  },
  showerSeat: {
    // siège de douche
    numberMax: 2,
    typeSrc: "glb",
    showAddButton: true,
    showReplaceButton: true,
    title: "Sièges de douche",
    titleSelectedObject: "Siège de douche",
  },
  wall: {
    typeSrc: "jpg",
    title: "Revêtement mural",
    titleSelectedObject: "Revêtement mural",
  },
  floor: {
    typeSrc: "jpg",
    title: "Revêtements sol",
    titleSelectedObject: "Revêtement sol",
  },
};
